import React from "react";
import { Chart } from "primereact/chart";
import ChartDivider from "../../ChartDivider";
import ChartSkeleton from "../../../Skeletons/ChartSkeleton";
import { getWeeklyChartOptions } from "../../../../utils/chartOptions/dashboard/frequency";
import { AVERAGE_WEEKLY_FREQUENCY_TEXT } from "../../../../utils/constants";

const UsesPerWeek = React.memo(function UsesPerWeek(props) {
  const { isShowChartTop = true } = props;
  const options = getWeeklyChartOptions(props?.usePerWeekGraph);
  return (
    <>
      <div className="mt-4" style={{ maxWidth: "100%" }}>
        <div className="mb-4">
          {isShowChartTop ? (
            <>
              <h5 className="fw-bold mb-2 text-start">
                {AVERAGE_WEEKLY_FREQUENCY_TEXT}
              </h5>
              {/* <h6 className="fw-bold mb-2 text-start">Base: Products</h6> */}
              <p
                className="mb-0 text-start fw-bold fs-12 pb-3"
                style={{ color: "#6c757d" }}
              >
                Average count of product uses per week
              </p>
            </>
          ) : (
            ""
          )}
          <div className="col-12">
            {!props?.loading ? (
              <Chart
                redraw={(props?.isFilterHide || props?.showSidebar).toString()}
                type="bar"
                data={props?.usePerWeekGraph}
                options={options}
              />
            ) : (
              <ChartSkeleton />
            )}
          </div>
          <ChartDivider />
        </div>
      </div>
    </>
  );
});

export default UsesPerWeek;
